export const GET_STEPSCOUNT_REQUEST = "GET_STEPSCOUNT_REQUEST";
export const GET_STEPSCOUNT_SUCCESS = "GET_STEPSCOUNT_SUCCESS";
export const GET_STEPSCOUNT_FAIL = "GET_STEPSCOUNT_FAIL";
export const RESET_STEPSCOUNT = "RESET_STEPSCOUNT";

export const GET_MEDICINE_REQUEST = "GET_MEDICINE_REQUEST";
export const GET_MEDICINE_SUCCESS = "GET_MEDICINE_SUCCESS";
export const GET_MEDICINE_FAIL = "GET_MEDICINE_FAIL";
export const RESET_MEDICINE = "RESET_MEDICINE";
